import { render, staticRenderFns } from "./NotificacaoUsuarioComPlano.vue?vue&type=template&id=a0ef88fe"
import script from "./NotificacaoUsuarioComPlano.vue?vue&type=script&lang=ts"
export * from "./NotificacaoUsuarioComPlano.vue?vue&type=script&lang=ts"
import style0 from "./NotificacaoUsuarioComPlano.vue?vue&type=style&index=0&id=a0ef88fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports